
function showInfoModal(data) {
  let title = '';
  let message = '';

  if (data) {
    if (data.title) {
      title = data.title;
    }

    if (data.message) {
      message = data.message;
    }
  }

  const infoModal = $('#info-modal');
  $('.modal-title', infoModal).html(title);

  // Check if message is a jQuery object or a string
  if (message instanceof jQuery) {
    $('.modal-body', infoModal).empty().append(message);
  } else {
    $('.modal-body', infoModal).html(message);
  }

  infoModal.modal('show');
}

export default showInfoModal;
